import axios from 'axios';
import { store } from 'store/store';

export const submitOpportunityLead = async (metaArea: MetaArea) => {
	try {
		const axiosInstance = axios.create({
			timeout: 30000,
		});

		axios.defaults.headers.common['accept'] = 'application/json';
		axios.defaults.headers.common['environment'] = 'ci';

		const productDetails = getProductDetails(metaArea);

		await sendEmailToKakao(productDetails, axiosInstance, metaArea);

		const url = metaArea.items[0].content.quoteOpportunityApiEndpoint.url;

		return await axiosInstance.post(url, getBody(productDetails));
	} catch (e) {
		console.error('Error in submitOpportunityLead:', e);
		throw e;
	}
};

const sendEmailToKakao = async (productDetails, axiosInstance, metaArea: MetaArea) => {
	try {
		const postboxId = 'codan-calculators-send-team-not-logged-in';
		const postbox = metaArea.items[0].content.calculatorEmailConfiguration?.items?.filter((item) => {
			if (item.content?.postboxNames) {
				for (const postboxNames of item.content.postboxNames) {
					if (postboxNames.postboxName.toLowerCase() === postboxId) {
						return true;
					}
				}
			}
		});

		if (postbox?.length > 0) {
			return await axiosInstance.post(postbox[0].content.url.url, {
				description: productDetails.descriptionEmail,
				subject: 'Codan Kunde ønsker ' + metaArea.items[0].content.productName,
				postboxId,
			});
		}
	} catch (e) {
		console.error(e);
	}
};

const getBody = (productDetails) => {
	try {
		const consent = getConsent();
		return {
			customer_details: getCustomerDetails(),
			opportunity_details: {
				description: productDetails.description,
				json_description: JSON.stringify(productDetails.jsonDescription),
			},
			quotes: [], // WAIT for SalesForce
			consents: consent ? [consent] : [],
			timeout: 30000,
			withCredentials: true,
		};
	} catch (e) {
		console.error(e);
		return {};
	}
};

const getConsent = () => {
	const form = store.getState().calculatorForm;

	if (form['CUSTOMER__HAS_FORMER_COMPANY']?.data?.value === 'Y' && form['CUSTOMER_CONSENT']?.data?.value === 'Y') {
		const companyId = form['CUSTOMER_FORMER_COMPANY']?.data?.value;
		const consent = {
			key: 'onlinetermination_private',
			start_date: new Date().toISOString(),
			competitors: [companyId],
		};

		return consent;
	}
};

const getCustomerDetails = () => {
	const form = store.getState().calculatorForm;

	const fullName = form['CUSTOMER_FULL_NAME']?.data?.value;

	const lastName = fullName?.split(/[, ]+/)?.pop();

	const firstNames = fullName?.replace(lastName, '')?.trim();

	const address = form['CUSTOMER_FULL_ADDRESS']?.data?.value
		? JSON.parse(form['CUSTOMER_FULL_ADDRESS']?.data?.value)
		: {};

	const customer_details = {
		validated_user: !!form['CUSTOMER_ID']?.data?.value,
		first_name: firstNames?.length > 0 ? firstNames : 'NA',
		last_name: lastName?.length > 0 ? lastName : 'NA',
		social_security_number: form['CUSTOMER_CPR']?.data?.value,
		customer_number: form['CUSTOMER_ID']?.data?.value,
		address: {
			street_name: address?.vejnavn,
			street_number: address?.husnr,
			street_code: address?.vejkode,
			postal_code: address?.postnr,
			city: address?.postnrnavn,
			country: 'DK',
			kvhx: address?.kvhx,
		},
		email: form['CUSTOMER_EMAIL']?.data?.value,
		mobile: form['CUSTOMER_PHONE']?.data?.value,
		//business_brand: '080796cf-3289-45a2-a1b2-5447e45fa099', // AB
		business_brand: '339996a3-4df2-4230-bfe9-3051a98500cb', // Codan, get from MetaArea CMS
	};
	return customer_details;
	// Dataforsyningen Address Response after adding kvh/kvhx
	// {
	//     "id": "0a3f509e-49e5-32b8-e044-0003ba298018",
	//     "status": 1,
	//     "darstatus": 3,
	//     "vejkode": "2136",
	//     "vejnavn": "Gasværksvej",
	//     "adresseringsvejnavn": "Gasværksvej",
	//     "husnr": "29",
	//     "etage": "2",
	//     "dør": "th",
	//     "supplerendebynavn": null,
	//     "postnr": "1656",
	//     "postnrnavn": "København V",
	//     "stormodtagerpostnr": null,
	//     "stormodtagerpostnrnavn": null,
	//     "kommunekode": "0101",
	//     "adgangsadresseid": "0a3f507a-7851-32b8-e044-0003ba298018",
	//     "x": 12.55810987,
	//     "y": 55.67016213,
	//     "href": "https://api.dataforsyningen.dk/adresser/0a3f509e-49e5-32b8-e044-0003ba298018"
	//     "kvhx": 123__243_45
	// }
};

export const getProductDetails = (metaArea: MetaArea) => {
	const productDefinition = metaArea.items[0].content;
	const prePackageName = productDefinition.calculatorParameterPrefix;
	const productName = productDefinition.productName;
	const productNameShort = productDefinition.shortProductName;

	const form = store.getState().calculatorForm;

	const prePackageData = {};
	const calculationData = {};
	const personInfoData = {};
	const coverageData = {};

	for (const key in form) {
		if (!form[key]) {
			// can be undefined or null (SUBMIT_INSURANCE_ERROR)
			continue;
		}
		const field = mapField(form[key].data);

		if (!field) {
			console.warn('Field mapping returned undefined for key:', key);
			continue;
		}

		if (key.startsWith('CUSTOMER_')) {
			personInfoData[field.label] = field.value;
		} else if (key.startsWith('SELECTED_PACKAGE')) {
			calculationData[field.label] = field.value;
		} else if (key.startsWith('COVERAGE_')) {
			coverageData[field.label] = field.value;
		} else if (key.startsWith(prePackageName)) {
			prePackageData[field.label] = field.value;
		}
	}

	const allData = { ...personInfoData, ...prePackageData, ...calculationData, ...coverageData };

	const jsonDescription = {
		products: [
			{
				productName,
				status: 'OK',
				description: {
					personInfoData,
					prePackageData,
					calculationData,
					coverageData,
				},
			},
		],
	};
	const yearly = form['SELECTED_PACKAGE_PAYMENT_FREQUENCY']?.data?.value === '1';
	const price = yearly
		? form['SELECTED_PACKAGE_YEARLY_PRICE']?.data?.value
		: form['SELECTED_PACKAGE_MONTHLY_PRICE']?.data?.value;
	const newLine = '\n';

	let description = price + ' ' + productNameShort + newLine;
	let descriptionEmail = '<h2>' + price + ' ' + productNameShort + '</h2><br/>';

	for (const key in allData) {
		description += key + ': ' + allData[key] + newLine;
		descriptionEmail += '<b>' + key + '</b>: ' + allData[key] + '<br/>';
	}
	return {
		description,
		descriptionEmail,
		jsonDescription,
	};
};

const mapField = (formField) => {
	switch (formField.type) {
		case 'SelectFieldBlock':
		case 'RadioCardFieldBlock':
		case 'RadioSliderBlock':
		case 'DatePickerFieldBlock':
			return {
				label: formField.stepTitle,
				value: formField.label,
			};

		case 'PACKAGE':
		case 'COVERAGE':
		case 'UserConsentBlock':
		case 'InputTextfieldBlock':
			return {
				label: formField.inputLabel,
				value: formField.value,
			};
		case 'SearchFieldBlock':
			return {
				label: formField.inputLabel,
				value: formField.label,
			};
	}
};
